var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ width: _vm.width })},_vm._l((_vm.lines),function(line,index){
var _obj;
return _c('p',{key:index,class:[(_vm.carbonPrefix + "--skeleton__text"), ( _obj = {}, _obj[(_vm.carbonPrefix + "--skeleton__heading")] = _vm.heading, _obj )],style:({ width: line.width })})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }